import Addmore from '../../assets/images/addmore.png'
import Grammar from '../../assets/images/grammar.png'
import Detector from '../../assets/images/detection.png'
import More from '../../assets/images/more.png'
import AutoModeIcon from '@mui/icons-material/AutoMode'
import SpellcheckIcon from '@mui/icons-material/Spellcheck'
import RadarIcon from '@mui/icons-material/Radar'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'

const ToolsSection = () => {
	return (
		<div className="py-10">
			<h2 className="text-center mb-8 text-5xl leading-snug">
				<span className="fancy-font bg-secondary">Polish</span> Your Essay
			</h2>
			<div className="grid grid-cols-1 md:grid-cols-2 gap-0">
				<div className="p-5 border-r-0 md:border-r border-dotted border-primary">
					<img
						src={Addmore}
						alt="add more to your essay"
						className="w-full md:w-1/2 mx-auto mb-5 object-contain h-40"
					/>
					<h3 className="text-2xl">
						<AutoModeIcon className="text-gray-700 mr-2 relative bottom-1" />
						AI Autocomplete
					</h3>
					<p className="text-gray-700 leading-relaxed mt-2">
						Get suggestions for your next paragraph based on the context of your essay.
					</p>
				</div>
				<div className="p-5">
					<img
						src={Grammar}
						alt="add more to your essay"
						className="w-full md:w-1/2 mx-auto mb-5 object-contain h-40"
					/>
					<h3 className="text-2xl">
						<SpellcheckIcon className="text-gray-700 mr-2 relative bottom-1" />
						Grammar Check
					</h3>
					<p className="text-gray-700 leading-relaxed mt-2">
						Ensure your essay is free of grammatical errors with our built-in grammar checker.
					</p>
				</div>
				<div className="p-5 border-t-0 md:border-t border-dotted border-primary md:border-r">
					<img
						src={Detector}
						alt="add more to your essay"
						className="w-full md:w-1/2 mx-auto mb-5 object-contain h-40"
					/>
					<h3 className="text-2xl">
						<RadarIcon className="text-gray-700 mr-2 relative bottom-1" />
						AI Detector
					</h3>
					<p className="text-gray-700 leading-relaxed mt-2">Ensure your essay is undetectable by AI detectors.</p>
				</div>
				<div className="p-5 border-t-0 md:border-t border-dotted border-primary">
					<img src={More} alt="add more to your essay" className="w-full md:w-1/2 mx-auto mb-5 object-contain h-40" />
					<h3 className="text-2xl">
						<AddCircleOutlineIcon className="text-gray-700 mr-2 relative bottom-1" />
						And More...
					</h3>
					<p className="text-gray-700 leading-relaxed mt-2">
						Use our AI assistant to help improve your essay, simplify sentences, and more.
					</p>
				</div>
			</div>
		</div>
	)
}

export default ToolsSection
